<div class="modal-header">
    <h2 class="modal-title">{{'request.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="filter-section-title">
        {{ "request.filterPopup.status" | translate }}
    </div>
    <div class="request-statuses-filters">
        <div class="request-status d-flex align-items-center" *ngFor="let status of requestsStatuses; index as i">
            <input kendoCheckBox
                type="checkbox"
                [id]="status.code + i"
                [size]="size"
                [rounded]="roundedLarge"
                [(ngModel)]="status.isSelected"
            />
            <label HJSuppress [for]="status.code + i" class="cursor-pointer user-select-none ms-2">
                {{ status.value }}
            </label>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'request.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyFilterHandler()">
        {{'request.filterPopup.apply' | translate}}
    </button>
</div>